import * as React from "react";
export function isMouseMoveEvent(e) {
    return "clientX" && "clientY" in e;
}
export default class Carousel extends React.Component {
}
